import api from './client';
import { UpdateStepData } from '@/types/assistants';
import { Step } from "@/types/assistants";

export const stepApi = {
    create: (data: any) =>
        api.post('/steps', data),

    getOne: (scenarioId: number) =>
        api.get('/steps', { params: { scenario_id: scenarioId } }),

    getOneStep: (id: string) =>
        api.get<Step>('/step/' + id),

    getAll: (scenarioId: number) =>
        api.get('/steps', { data: { scenario_id: scenarioId } }),

    update: (data: UpdateStepData) =>
        api.put('/steps', data),

    delete: (scenarioId: number, id: number) =>
        api.delete('/steps', { data: { scenario_id: scenarioId, id } }),
};
